// Fixed viewport coordinates: the popup is rendered outside the scrolling chat.
function reportMenuPosition(anchor, viewportWidth, viewportHeight) {
  const margin = 8, gap = 6, height = 44;
  const width = Math.min(144, Math.max(0, viewportWidth - 2 * margin));
  const left = Math.max(margin, Math.min(anchor.right - width, viewportWidth - width - margin));
  const candidate = anchor.top >= height + gap + margin ? anchor.top - height - gap : anchor.bottom + gap;
  const top = Math.max(margin, Math.min(candidate, viewportHeight - height - margin));
  return { left, top, width };
}
module.exports = { reportMenuPosition };
